import { AuthenticateWithRedirectCallback } from "@clerk/react";

import { routes } from "@/routes";

import { SignInPage } from "./signin/sign-in-page";

export function OAuthCallbackPage() {
  return (
    <AuthenticateWithRedirectCallback
      firstFactorUrl={routes.oauthSignIn}
      resetPasswordUrl={routes.oauthSignIn}
      secondFactorUrl={routes.oauthSignIn}
      signInFallbackRedirectUrl={routes.profile}
      signInUrl={routes.oauthSignIn}
      signUpFallbackRedirectUrl={routes.onboarding}
      signUpUrl={routes.signup}
      transferable={false}
    />
  );
}

export function OAuthSignInPage() {
  return <SignInPage />;
}
